import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: "root"
})
export class EncryptionService {
  // Cust code and mobile number e/d key respectively
  key: any = "KCu02iV+X1OYq6NxCNnS1Mg7";

  // Link generation key UAT and LIVE respectively
  // key2: any = "C*F-JaNdRgUkXp2r5u8x/A?D(G+KbPeS";
  key2: any = "7x!A%D*G-KaPdSgVkYp3s6v9y/B?E(H+";
  IV = "";
  request;
  encryptedAes;
  decryptedAes;

  // ENCRYPTION USING ECB TRIPLE DES
  encryptUsingTripleDES(res: any, typeObj: boolean): string {
    const data = res;
    const keyHex = CryptoJS.enc.Utf8.parse(this.key);
    const iv = CryptoJS.enc.Utf8.parse(this.IV);
    const mode = CryptoJS.mode.ECB;
    const encrypted = CryptoJS.TripleDES.encrypt(data, keyHex, { iv, mode });
    return encrypted.toString();
  }

  // DECRYPTION USING ECB TRIPLE DES
  decryptUsingTripleDES(encrypted: string): string {
    const keyHex = CryptoJS.enc.Utf8.parse(this.key);
    const iv = CryptoJS.enc.Utf8.parse(this.IV);
    const mode = CryptoJS.mode.ECB;
    const decrypted = CryptoJS.TripleDES.decrypt(encrypted, keyHex, { iv, mode });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptUsingAES256(args) {
    let _key = CryptoJS.enc.Utf8.parse(this.key2);
    let _iv = CryptoJS.enc.Utf8.parse(this.IV);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(args), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      // console.log(encrypted.toString());
    return encrypted.toString();
  }
  decryptUsingAES256(args) {
    let _key = CryptoJS.enc.Utf8.parse(this.key2);
    let _iv = CryptoJS.enc.Utf8.parse(this.IV);

    return CryptoJS.AES.decrypt(
      args, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
  }
}